import { useEffect, useState } from "react";
import Header from "../components/common/header";
import Footer from "../components/common/footer";

import {
  FiZap,
  FiTrendingUp,
  FiActivity,
  FiCpu,
  FiAlertTriangle,
} from "react-icons/fi";

const SIGNAL_META = {
  NEW_CONTRACT_DEPLOY: {
    label: "New Contract",
    icon: <FiZap />,
    color: "#8aff8a",
  },
  FIRST_TOKEN_ACTIVITY: {
    label: "First Activity",
    icon: <FiAlertTriangle />,
    color: "#ffd27d",
  },
  REAL_SWAP: {
    label: "Swap",
    icon: <FiTrendingUp />,
    color: "#6ab7ff",
  },
  LARGE_VALUE_TX: {
    label: "Large Tx",
    icon: <FiActivity />,
    color: "#ff6a6a",
  },
  BOT_LIKE_TX: {
    label: "Bot-like",
    icon: <FiCpu />,
    color: "#c792ff",
  },
};

export default function SignalFeedPage() {
  const [signals, setSignals] = useState([]);

  useEffect(() => {
    const ws = new WebSocket("wss://cryptospace.network/wallet-feed");

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        setSignals((prev) => [msg, ...prev].slice(0, 100));
      } catch {
        // ignore malformed messages
      }
    };

    return () => ws.close();
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#000",
      }}
    >
      <Header />

      <div
        style={{
          flex: 1,
          padding: "24px",
          maxWidth: "1100px",
          margin: "0 auto",
          color: "#fff",
        }}
      >
        <h1>Live Signal Feed</h1>
        <p style={{ color: "#aaa", marginBottom: 24 }}>
          Curated real-time on-chain signals generated by the infrastructure.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {signals.map((s, i) => {
            const meta = SIGNAL_META[s.event] || {};
            return (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: 12,
                  padding: "12px 16px",
                  border: "1px solid #222",
                  borderRadius: 8,
                  background: "#0a0a0a",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 20,
                    color: meta.color || "#777",
                  }}
                >
                  {meta.icon || <FiActivity />}
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600 }}>
                    {meta.label || s.event}
                  </div>
                  <div
                    style={{
                      fontSize: 13,
                      color: "#888",
                      wordBreak: "break-all",
                    }}
                  >
                    {s.txHash || "—"}
                  </div>
                </div>

                <div
                  style={{
                    fontSize: 12,
                    color: "#666",
                    whiteSpace: "nowrap",
                  }}
                >
                  {s.net?.toUpperCase()}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
}